import React  from 'react';
import InvoiceMaintenanceMngTemplate from '../../components/invoiceMaintenanceMng/InvoiceMaintenanceMngTemplate';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';



const InvoiceMaintenanceMngPage = () => {
  return (
    <div>
      <BreadcrumbsContainer title="수주 관리 / MA 매출 계산서 발행 / 발행 리스트" icon="common"/>
      <InvoiceMaintenanceMngTemplate/>
    </div>
  );
};

export default InvoiceMaintenanceMngPage;
